<template>
    <div class="tree-container">
        <div class="title-wrap" v-if="title">
            <span class="split-line"></span>
            {{ title }}{{ cascadingVar ? "：" : ""
            }}<el-checkbox
                @change="cascadingVarChange"
                v-show="cascadingVar"
                v-model="check"
                >级联选择</el-checkbox
            >
        </div>
        <div class="button-wrap" v-if="treeToolBar">
            <el-button
                class="iconfont icon-add addBtn"
                type="text"
                size="mini"
                @click="handleAddTreeNode"
            >
                {{ btnName }}
                <div class="total">
                    {{ departTotal }}
                </div>
            </el-button>
        </div>
        <div class="search-wrap" v-if="treeSearchBar">
            <el-input
                prefix-icon="el-icon-search"
                size="mini"
                placeholder="搜索"
                @change="searchChange"
                v-model="searchText"
                clearable
            >
            </el-input>
        </div>
        <div class="buttonCont" v-if="toolBtn">
            <el-button type="text" size="mini" @click="checkAll"
                >全选</el-button
            >
            <el-button type="text" @click="inverse" size="mini">反选</el-button>
        </div>
        <el-scrollbar :style="{ height: this.countheight }">
            <el-tree
                ref="tree"
                :data="treeData"
                highlight-current
                :node-key="nodeKey"
                :check-strictly="checkStrictly"
                :check-on-click-node="isCheckClick"
                :expand-on-click-node="false"
                :default-expand-all="defaultExpandAll"
                :default-expanded-keys="defaultExpandedKeys"
                :props="defaultProps"
                :default-checked-keys="defaultCheckKeys"
                :show-checkbox="showCheckbox"
                @node-click="handleNodeClick"
                @check="handleCheckBoxClick"
                :accordion="accordion"
                :render-content="renderContent"
                :filter-node-method="filterNode"
                :draggable="draggable"
                :allow-drop="allowDrop"
                @node-drag-end="handleDragEnd"
            >
            </el-tree>
        </el-scrollbar>
    </div>
</template>
<script>
export default {
    data() {
        return {
            check: false,
            searchText: "",
            flag: false,
            nodesList: [],
        };
    },
    props: {
        treeData: {
            //树数据
            type: Array,
        },
        treeLoading: {
            //树loading状态
            type: Boolean,
            default: false,
        },
        treeToolBar: {
            //是否显示新增修改删除按钮
            type: Boolean,
            default: false,
        },
        defaultProps: {
            //默认树节点属性设置
            type: Object,
            default: () => {
                return {
                    children: "children",
                    label: "label",
                };
            },
        },
        nodeKey: {
            //指定唯一标识字段
            type: String,
            default: "id",
        },
        showCheckbox: {
            //是否显示checkbox
            type: Boolean,
            default: false,
        },
        checkStrictly: {
            // 遵循父子不互相关联的做法
            type: Boolean,
            default: false,
        },
        defaultCheckKeys: {
            //默认checkbox选中
            type: Array,
            default: () => {
                return [];
            },
        },
        isSingle: {
            //checkbox  是否单选
            type: Boolean,
            default: false,
        },
        isCheckClick: {
            //是否在点击节点的时候选中节点
            type: Boolean,
            default: true,
        },
        defaultExpandAll: {
            //默认是否展开全部子节点
            type: Boolean,
            default: false,
        },
        defaultExpandedKeys: {
            //默认展开指定子节点
            type: Array,
            default: () => {
                return [];
            },
        },
        title: {
            //树标题
            type: String,
            default: false,
        },
        cascadingVar: {
            type: Boolean,
            default: false,
        },
        departTotal: {
            type: Number,
            default: "",
        },
        btnName: {
            type: String,
            default: "新增",
        },
        treeSearchBar: {
            type: Boolean,
            default: false,
        },
        accordion: {
            type: Boolean,
            default: false,
        },
        renderContent: {
            type: Boolean,
            default: false,
        },
        // 功能性按钮  全选 反选
        toolBtn: {
            type: Boolean,
            default: false,
        },
        draggable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        countheight() {
            let num = 0;
            if (this.title) {
                num++;
            }
            if (this.treeSearchBar) {
                num++;
            }
            if (this.treeToolBar) {
                num++;
            }
            if (this.toolBtn) {
                num++;
            }
            return `calc(100% - ${40 * num}px)`;
        },
    },
    watch: {
        treeData: {
            handler(newValue) {
                this.treeData = newValue;
            },
            deep: true,
            immediate: true,
        },
        checkStrictly: {
            handler(newValue) {
                this.checkStrictly = newValue;
                this.check = !this.checkStrictly;
            },
            deep: true,
            immediate: true,
        },
        searchText(val) {
            this.$refs.tree.filter(val);
        },
    },
    methods: {
        /**
         * 数节点点击事件
         * 默认参数共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身。
         */
        handleNodeClick(data, node) {
            this.selectTree = data;
            this.$emit("handleTreeNodeClick", data, node);
            let nodeKey = this.nodeKey;
            this.$nextTick(() => {
                if (!this.showCheckbox) {
                    this.$refs.tree.setCurrentKey(data[nodeKey]);
                }
            });
        },
        handleCheckBoxClick(node, Selected) {
            this.selectTree = node;
            this.$emit("handleCheckBoxClick", {
                node: node,
                Selected: Selected,
            });
            let nodeKey = this.nodeKey;
            this.$nextTick(() => {
                if (this.isSingle) {
                    this.$refs.tree.setCheckedKeys([node[nodeKey]]);
                }
            });
        },
        /**
         * 搜索
         */
        searchChange() {
            this.$emit("searchChange", this.searchText);
        }
        /**
         * 过滤
         */,
        filterNode(value, data) {
            if (!value) return true;
            return (
                data[this.defaultProps.label]
                    .toLowerCase()
                    .indexOf(value.toLowerCase()) !== -1
            );
        },
        /**
         * 添加树节点
         */
        handleAddTreeNode() {
            this.$emit("handleAddTreeNode", this.selectTree);
        },
        /**
         * 编辑树节点
         */
        handleEditTreeNode() {
            this.$emit("handleEditTreeNode", this.selectTree);
        },
        /**
         * 删除树节点
         */
        handleDelTreeNode() {
            this.$emit("handleDelTreeNode", this.selectTree);
        },
        /**
         * 级联复选框值改变回调函数
         */
        cascadingVarChange(e) {
            this.$emit("update:checkStrictly", !e);
        },
        // 全选或反选
        checkAll() {
            this.flag = true;
            this.$refs.tree.setCheckedNodes(this.treeData);
            this.nodesList = this.treeData;
            this.getSelect_box();
        },
        // 反选处理方法
        batchSelect(nodes, refs, flag, seleteds) {
            if (typeof nodes != "undefined") {
                nodes.forEach((element) => {
                    refs.setChecked(element, flag, true);
                });
            }

            if (typeof seleteds != "undefined") {
                seleteds.forEach((node) => {
                    refs.setChecked(node, !flag, true);
                });
            }
            this.nodesList = this.arrSubtraction(nodes, seleteds);
            this.getSelect_box();
        },
        // 反选
        inverse() {
            let nodes = this.$refs.tree.getCheckedNodes(true, true);
            this.batchSelect(this.treeData, this.$refs.tree, true, nodes);
        },
        getSelect_box() {
            let select_box = [];
            this.$refs.tree.getCheckedNodes().forEach((item) => {
                select_box.push(item[this.nodeKey]);
            });
            this.$emit("select_box", {
                idList: select_box,
                nodesList: this.nodesList,
            });
        },
        arrSubtraction(a, b) {
            if (Array.isArray(a) && Array.isArray(b)) {
                return a.filter((i) => !b.includes(i));
            }
        },
        // 判断目标节点能否被放置
        allowDrop(moveNode, inNode, type) {
            return true;
        },
        handleDragEnd(draggingNode, dropNode, dropType, ev) {
            // console.log(
            //     "tree drag end: ",
            //     dropNode && dropNode.label,
            //     dropType
            // );
            this.$emit("allowDrop", { draggingNode, dropNode, dropType });
        },
    },
};
</script>
<style lang="scss">
.tree-container {
    width: 100%;
    height: 100%;
    min-width: 250px;
    overflow-y: auto;

    .addBtn {
        font-size: 14px;
        width: 100%;
        height: 40px;
        text-align: left;
        text-indent: 20px;
        border-bottom: 1px #ddd solid;
        .total {
            float: right;
            padding-right: 20px;
        }
    }
    .search-wrap {
        padding: 6px;
        padding-bottom: 0;
    }
    .button-wrap {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        // margin-bottom: 20px;
    }
    .buttonCont {
        width: 100%;
        // display: flex;
        // flex-direction: row;
        padding: 0 30px;
        box-sizing: border-box;
    }
    .el-tree-node__label {
        @include ellipsis();
        text-align: left;
        font-size: 12px;
    }
    .title-wrap {
        text-align: left;
        font-size: 14px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-left: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: left;
        border-bottom: 1px solid #dedede;
        .title {
            padding-right: 10px;
        }
        .split-line {
            display: inline-block;
            background: $color-primary;
            width: 4px;
            height: 14px;
            border-radius: 2px;
            margin-right: 10px;
        }
    }
    .el-scrollbar__wrap {
        .el-scrollbar__view {
            box-sizing: border-box;
            padding: 10px;
        }
    }
    .el-scrollbar .el-scrollbar__wrap {
        overflow-x: hidden !important;
    }
}
</style>
